import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'EpideMap', requiresAuth: false },
    },
    {
      path: '/case_map',
      name: 'case-map',
      component: () => import(/* webpackChunkName: "case-map" */ './views/CaseMap.vue'),
      meta: { title: 'Mapa de Casos', requiresAuth: true },
    },
    {
      path: '/help_map',
      name: 'help-map',
      component: () => import(/* webpackChunkName: "help-map" */ './views/HelpMap.vue'),
      meta: { title: 'Mapa de Ajuda', requiresAuth: true },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: { title: 'Sobre', requiresAuth: true },
    },
    {
      path: '/board',
      name: 'board',
      component: () => import(/* webpackChunkName: "board" */ './views/Board.vue'),
      meta: { title: 'Mural', requiresAuth: true },
    },
    {
      path: '/update_status',
      name: 'update-status',
      component: () => import(
        /* webpackChunkName: "update-status" */ './views/UpdateStatus.vue'
      ),
      meta: { title: 'Atualizar Situação', requiresAuth: true },
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: () => import(/* webpackChunkName: "statistics" */ './views/Statistics.vue'),
      meta: { title: 'Estatísticas', requiresAuth: true },
    },
    {
      path: '/my_info',
      name: 'my-info',
      component: () => import(/* webpackChunkName: "my-info" */ './views/MyInfo.vue'),
      meta: { title: 'Meus Dados', requiresAuth: true },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/auth/Login.vue'),
      meta: { title: 'Login', requiresAuth: false },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "register" */ './views/auth/Register.vue'),
      meta: { title: 'Cadastro', requiresAuth: false },
    },
    {
      path: '/send_email_reset_password',
      name: 'send-email-reset-password',
      component: () => import(
        /* webpackChunkName: "send-email-reset-password" */ './views/auth/SendEmailResetPassword.vue'
      ),
      meta: { title: 'Redefinir Senha', requiresAuth: false },
    },
    {
      path: '/auth_settings',
      name: 'auth-settings',
      component: () => import(
        /* webpackChunkName: "auth-settings" */ './views/auth/AuthSettings.vue'
      ),
      meta: { title: 'Covid19Map', requiresAuth: false },
    },
    {
      path: '/ask_help',
      name: 'ask-help',
      component: () => import(/* webpackChunkName: "ask-help" */ './views/AskHelp.vue'),
      meta: { title: 'Pedir Ajuda', requiresAuth: true },
    },
    {
      path: '/offer_help',
      name: 'offer-help',
      component: () => import(/* webpackChunkName: "offer-help" */ './views/OfferHelp.vue'),
      meta: { title: 'Oferecer Ajuda', requiresAuth: true },
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "terms" */ './views/Terms.vue'),
      meta: { title: 'Termos de Uso', requiresAuth: false },
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const { store } = router.app.$options;
  store.commit('loadingRouteStart');
  await store.dispatch('autoLogin');
  if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    next({ name: 'login' });
    return;
  }
  if (
    to.name
    && (to.name === 'login' || to.name === 'register' || to.name === 'home')
    && store.getters.isAuthenticated
  ) {
    next({ name: 'case-map' });
    return;
  }
  next();
});

router.afterEach((to) => {
  const { store } = router.app.$options;
  if (to.meta.title) document.title = to.meta.title;
  store.commit('loadingRouteEnd');
});

export default router;
